module.exports = __webpack_public_path__ + "assets/images/outfit-02.57f35a2b9b6cee7dd94790a7a2af8669.svg";